import styled, { createGlobalStyle, css, keyframes } from 'styled-components';
import { Button } from '@bexs/dollar';
import { colors as rawColors } from './colors/raw';
import { colorVariables } from './colors/variables';
import { KMRApparat } from './font-face';

const primaryColor = rawColors['primary/1000'];

const fadeAnimation = keyframes`
  0% {
    background-color: rgba(0, 190, 240, 1);
  }
  50% {
    background-color: rgba(0, 190, 240, 0);
  }
  100% {
    background-color: rgba(0, 190, 240, 1);
  }
`;

const rotateAnimation = keyframes`
  0% {
    transform: rotate(45deg);
    background-color: rgba(0, 190, 240, 1);
  }
  50% {
    background-color: rgba(0, 190, 240, 0);
  }
  100% {
    transform: rotate(405deg);
    background-color: rgba(0, 190, 240, 1);
  }
`;

export default createGlobalStyle`

  ${KMRApparat}

  :root {
    ${colorVariables}    
    --typography__fontFamily--primary: 'KMR Apparat', sans-serif;
  }

  *, *::after, *::before {
    box-sizing: border-box;
    font-family: var(--typography__fontFamily--primary); // Garate que a nova fonte esta sobreescrevendo a fonte do bexs-dollar
  }
  
  html {
    font-family: var(--typography__fontFamily--primary); // Garate que a nova fonte esta sobreescrevendo a fonte do bexs-dollar
  }

  body {
    margin: 0;
    padding: 0;
    -webkit-font-smoothing: antialiased;
    background-color: ${rawColors['neutral/100']};    
    font-family: var(--typography__fontFamily--primary);
  }


  div[data-testid="calendar-month"] > div > button {
    border-color: ${primaryColor};
    &:hover {
      &::after {
        background-color: ${primaryColor};
      }
    }
  }

  div[data-testid="calendar-year"] > ul {
    border-color: ${primaryColor};
  }

  div[data-testid="calendar-year"] > ul > li {
    &::before {
      background-color: ${primaryColor};
    }
  }
  
  button[data-testid="calendar-day"][data-testishighlighted="true"]::before {
    background-color:var(${rawColors['primary/500']});
  }
  button[data-testid="calendar-day"][data-testishighlighted="true"]::after {
    background-color: ${primaryColor};
  }


  input[data-testid="input-component"] {
    &:focus {
      border-color: ${primaryColor};
    }
  }

  div[data-testid="content-upload-box"] span {
    color: ${primaryColor};
  }


  thead[data-testid="table-header-component"] > tr {
    border-bottom: 2px solid ${primaryColor} !important;
  }
  div[data-testid="table-container"] {
    border-bottom: 2px solid ${primaryColor} !important;
  }


  div[data-testid="loader"] > div,
  div[data-testid="loader-component"] > div {
    animation: ${rotateAnimation} 1.3s ease-in-out infinite !important;
    div {
      border-color: ${primaryColor} !important;
      animation: ${fadeAnimation} 1.3s ease-in-out infinite;
      &::before,
      &::after {
        animation: ${fadeAnimation} 1.3s ease-in-out infinite;
      }
    }
  }
`;

export const CustomButton = styled(Button)`
  ${({ variation, theme }) => {
    switch (variation) {
      case 'primary':
        return css`
          border-color: ${theme.colors.primary};
          background-color: ${theme.colors.primary};
          &:hover {
            background-color: ${theme.colors.primary};
            border-color: ${theme.colors.primary};
          }
        `;
      case 'primary-outline':
        return css`
          border-color: ${theme.colors.primary};
          color: ${theme.colors.primary};
          &:hover {
            background-color: ${theme.colors.primary};
          }
        `;
      default:
        return css``;
    }
  }}
`;
